<template>
  <img class="hint-img" @click="$emit('click')" :src="isCollapsing ? '../../../../static/actions/collapse.svg' : '../../../../static/actions/expand.svg'" alt="Icon to demonstrate grouping action">
</template>

<script>
export default {
  name: 'GroupTogetherIcon',
  props: {
    isCollapsing: {
      default: true
    }
  }
}
</script>

<style scoped>
.hint-img {
  cursor: pointer;
  margin: 0 4px;
  width: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/utils/buttons/GroupingIcon.vue